export default function parseMultipleModals(
  props: Queries.ContentfulSection001,
) {
  const { subsections } = props;

  const modals = subsections
    ?.map((subsection) => {
      const metadata = (subsection as unknown as Queries.ContentfulModal001)
        ?.content?.[0]?.metadata;

      if (!metadata) {
        return null;
      }

      const { title, description, ctas, metadata_id } = metadata;

      return {
        heading: title,
        content: description?.description,
        id: metadata_id,
        cta: ctas?.[0],
      };
    })
    .filter((modal) => modal !== null);

  return {
    modals,
  };
}
